module.exports = __webpack_public_path__ + "img/gry_1.fad9cb68.png";